import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";
import { IRootScope } from "@models";
import { StateDeclaration, Transition, TransitionService } from "@uirouter/angularjs";
import * as angular from "angular";

export interface IDrawer {
    icon?: string;
    label?: string;
    command?: () => any;
    /** an optional function to read whether the drawer is visible or not */
    visible?: boolean;
    disabled?: boolean;
    /** custom content */
    content?: JQuery;
    children?: IDrawer[];
    /** starts a new button group to put space between it and the button to the left of it (used in kbSfdcHeader) */
    startGroup?: boolean;
    /** ends a button group (used in kbSfdcHeader) */
    endGroup?: boolean;
    /** custom classes to put on the drawer element */
    classes?: string;
    /** for drawers that act like toggle buttons */
    selected?: boolean;
}

@NgService({
    token: Token.DrawerService,
    dependencies: [
        Token.$RootScope,
        Token.KbService,
        Token.$Transitions
    ]
})
export class DrawerService {
    constructor(
        private $rootScope: IRootScope,
        private kbService: KbService,
        private $transitions: TransitionService
    ) {
        this.drawers = [];
        this.showHelp = true;

        $transitions.onEnter({}, (transition: Transition, state: StateDeclaration) => {
            if (state.name) {
                // clear out drawer
                this.drawers.clear();
                this.pageTitle = null;
                this.pageIcon = null;
                this.pageType = null;
                this.showHelp = true;
            }
        });
    }

    public drawers: IDrawer[];
    public helpUrl: string;
    public showHelp: boolean;
    public pageTitle: string;
    public pageIcon: string;
    public pageType: string;

    public setHelpUrl(url: string) {
        if (!url) url = "KBMax+CPQ";
        this.helpUrl = "https://cpqhelp.link/" + url.toLowerCase();
    }
                
    public addDrawer(icon: string, label: string, command: any, visible?: boolean, children?: IDrawer[]): IDrawer {
        if (!angular.isDefined(visible)) {
            visible = true;
        }
        let drawer = {
            icon,
            label,
            command: () => { if (!drawer.disabled) return command() },
            visible,
            disabled: false,
            children
        };

        this.drawers.push(drawer);

        return drawer;
    }
}
